import { defineComponent as _defineComponent } from 'vue'
import { nextTick, ref, watch } from 'vue';
import type { ProofreadingIssue } from '@/types/proofreading';
import ProofreadingCategoryAccordion from '@/components/organisms/proofreading/shared/ProofreadingCategoryAccordion.vue';
import IssueItem from './IssueItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueListGroup',
  props: {
    categoryId: { type: String, required: true },
    label: { type: String, required: true },
    issues: { type: Array, required: true },
    activeIssueIds: { type: Array, required: true },
    defaultOpen: { type: Boolean, required: false }
  },
  emits: ["issue-click", "issue-apply", "issue-revert", "issue-reject-toggle", "issue-hover"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'issue-click', payload: { issueId: string; episodeKey: string }): void;
    (event: 'issue-apply', payload: { categoryId: string; issue: ProofreadingIssue }): void;
    (event: 'issue-revert', payload: { categoryId: string; issue: ProofreadingIssue }): void;
    (event: 'issue-reject-toggle', payload: { categoryId: string; issue: ProofreadingIssue }): void;
    (event: 'issue-hover', issue: ProofreadingIssue, isHovered: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    categoryId: string;
    label: string;
    issues: ProofreadingIssue[];
    activeIssueIds: string[];
    defaultOpen?: boolean;
};





const accordionRef = ref<InstanceType<typeof ProofreadingCategoryAccordion> | null>(null);

function openAccordionIfGroupHasActiveIssue(issueIds: string[]) {
    if (issueIds.length === 0) return;
    const isInGroup = props.issues.some(
        (issue) =>
            issueIds.includes(issue.id)
            || (issue.locations?.some((loc) => issueIds.includes(loc.id)) ?? false),
    );
    if (isInGroup) {
        accordionRef.value?.open();
    }
}

watch(
    () => props.activeIssueIds,
    (issueIds) => {
        nextTick(() => {
            openAccordionIfGroupHasActiveIssue(issueIds);
        });
    },
    { deep: true },
);

function isIssueActive(issue: ProofreadingIssue): boolean {
    // target 未設定（初期状態）ではすべてフル opacity にする
    if (props.activeIssueIds.length === 0) return true;
    return props.activeIssueIds.some(
        (activeId) =>
            issue.id === activeId || (issue.locations?.some((loc) => loc.id === activeId) ?? false),
    );
}

function onClickIssue(payload: { issueId: string; episodeKey: string }) {
    emit('issue-click', payload);
}

function onApplyIssue(issue: ProofreadingIssue) {
    emit('issue-apply', { categoryId: props.categoryId, issue });
}

function onRevertIssue(issue: ProofreadingIssue) {
    emit('issue-revert', { categoryId: props.categoryId, issue });
}

function onRejectToggleIssue(issue: ProofreadingIssue) {
    emit('issue-reject-toggle', { categoryId: props.categoryId, issue });
}

function onHoverIssue(issue: ProofreadingIssue, isHovered: boolean) {
    emit('issue-hover', issue, isHovered);
}

return { __sfc: true,props, emit, accordionRef, openAccordionIfGroupHasActiveIssue, isIssueActive, onClickIssue, onApplyIssue, onRevertIssue, onRejectToggleIssue, onHoverIssue, ProofreadingCategoryAccordion, IssueItem }
}

})